import { create } from 'zustand';
import { api } from '../lib/api';

interface SettingsState {
  hasLlmKey: boolean;
  loadLlmKeyStatus: () => Promise<void>;
  setHasLlmKey: (v: boolean) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  hasLlmKey: false,

  loadLlmKeyStatus: async () => {
    try {
      const { hasKey } = await api.getLlmKeyStatus();
      set({ hasLlmKey: hasKey });
    } catch {
      set({ hasLlmKey: false });
    }
  },

  setHasLlmKey: (v) => set({ hasLlmKey: v }),
}));
